import KeenSlider from "keen-slider";
window.simpleSliderObj = () => {

	const sliders = document.getElementsByClassName("simple-slider");
	[...sliders].forEach(function (slider) {
		const sliderId = slider.id;
		const sliderElement = document.getElementById(sliderId);
		const prevButton = sliderElement?.querySelector(".arrow.arrow--left");
		const nextButton = sliderElement?.querySelector(".arrow.arrow--right");
		const autoplaySpeed = parseInt(sliderElement.getAttribute("data-autoplay-speed")) * 1000;

		let {
			view_desktop_large,
			view_desktop,
			viewTablet,
			viewMobile,
			customClass,
			spacingDesktopLarge,
			spacingDesktop,
			spacingMobile,
			spacingTablet,
			disableSlider,
			disableLoop
		} = sliderElement.dataset;

		const sliderContent = sliderElement.querySelector(".slider-content");
		const SliderVideoWrapper = sliderContent.querySelectorAll("video");
		sliderContent.removeAttribute("loading");

		let keenSlider;
		let currentSlider = 0;

		disableLoop === "true" ? disableLoop = true : disableLoop = false;

		disableSlider === "true" ? disableSlider = true : disableSlider = false;

		let autoplay = sliderElement.dataset.autoplay === "true";
		let centerMode = sliderElement.dataset.centerMode === "true";
		let bulletStatus = sliderElement.dataset.bullets === "true";

		if (customClass == "collections__slider") viewMobile = "auto";
	
		if(!customClass == 'how-use_slider'){
			view_desktop_large == 1 ? (view_desktop_large = "auto") : "";
			view_desktop == 1 ? (view_desktop = "auto") : "";
			viewTablet == 1 ? (viewTablet = "auto") : "";
			viewMobile == 1 ? (viewMobile = "auto") : "";
		}

		const breakpoints = {
			"(min-width: 0px)": {
				slides: {
					loop: disableLoop,
					perView: viewMobile,
					spacing: spacingMobile,
					origin: centerMode,
				},
			},
			"(min-width: 767px)": {
				slides: {
					loop: disableLoop,
					perView: viewTablet,
					spacing: spacingTablet,
					origin: centerMode,
				},
			},
			"(min-width: 1024px)":{
				disabled: disableSlider,
				slides: {
					loop: disableLoop,
					perView: view_desktop,
					spacing: spacingDesktop,
					origin: centerMode,
				},
			},
			"(min-width: 1480px)": {
				disabled: disableSlider,
				slides: {
					loop: disableLoop,
					perView: view_desktop_large,
					spacing: spacingDesktopLarge,
					origin: centerMode,
				},
			},
		};

		const initializeSlider = function () {
			keenSlider = new KeenSlider(sliderElement, {
				duration: 1000,
				mode: "snap",
				dragSpeed: 0.5,
				dragStart: function () {
					sliderElement.classList.add("slider--dragging");
				},
				dragEnd: function () {
					sliderElement.classList.remove("slider--dragging");
				},
				breakpoints: breakpoints,
				slideChanged: function (s) {
					const currentSlide = s.track.details.rel;


					if (currentSlide != 0) {
						prevButton?.classList.remove('hidden')
					}else{
						prevButton?.classList.add('hidden')
					}

					if (currentSlide == s.track.details.slides.length - 1) {
						nextButton?.classList.add('hidden')
					}else{
						nextButton?.classList.remove('hidden')
					}

					const videos = sliderElement.querySelectorAll(".video-player");
					videos.forEach((slide) => slide.classList.remove("active"));
					if (currentSlide !== undefined && currentSlide !== null) {
						videos[currentSlide]?.classList.add("active");
					}

					updateActiveBullet(s);
				},
				
			});
			if (bulletStatus) {
				generateBullets(sliderElement, keenSlider.track.details.slides.length);
			}

			prevButton?.addEventListener("click", function () {
				keenSlider.prev();
			});

			nextButton?.addEventListener("click", function () {
				keenSlider.next();
			});

			if (autoplay) {
				startAutoplay(sliderElement);
			}
		};

		// Generar bullets
		const generateBullets = function (sliderElement, slideCount) {
			let bulletsContainer = sliderElement.querySelector('.bullets');
			if (!bulletsContainer) { 
				bulletsContainer = document.createElement('div');
				bulletsContainer.className = 'bullets';
				sliderElement.appendChild(bulletsContainer);
			} else {
				bulletsContainer.innerHTML = ''; 
			}
            
            for (let i = 0; i < slideCount; i++) {
                const bullet = document.createElement('button');
                bullet.className = 'bullet';
                bullet.dataset.index = i;
				if (i == 0) bullet.classList.add('active');
                bullet.addEventListener('click', function () {
                    keenSlider.moveToIdx(parseInt(this.dataset.index));
                });
                bulletsContainer.appendChild(bullet);
            }
        };

        const updateActiveBullet = function (s) {
			const activeSlideIndex = s.track.details.rel;
			const bullets = sliderElement.querySelectorAll('.bullet');
			bullets.forEach(bullet => bullet.classList.remove('active'));
			bullets[activeSlideIndex]?.classList.add('active');
        };

		const startAutoplay = function (element) {
			if (autoplaySpeed > 0 && element) {
				keenSlider.interval = setInterval(function () {
					keenSlider.next();
				}, autoplaySpeed);
			}
		};

		const stopAutoplay = function () {
			if (keenSlider.interval) {
				clearInterval(keenSlider.interval);
			}
		};

		initializeSlider();

		sliderElement.addEventListener("mouseover", function () {
			stopAutoplay();
		});

		sliderElement.addEventListener("mouseout", function () {
			autoplay ? startAutoplay() : "";
		});
	  
		// Video events
		SliderVideoWrapper?.forEach((video, index) => {
			const btnPlay = video.parentElement.querySelector(".play-button");
			const muteButton = video.parentElement.querySelector(".mute-button");
			const progressBar = video.parentElement.querySelector(".progress");

			video.parentElement.addEventListener("mouseenter", function () {
				const sourceTag = video.querySelector("source[data-src]");
				if (sourceTag && !sourceTag.getAttribute("src")) {
					const videoSrc = sourceTag.getAttribute("data-src");
					sourceTag.setAttribute("src", videoSrc);
					video.load();
				}
			});

			const clickHandler = (e) => {
				e.preventDefault();

				if (!video.paused) {
					video.pause();
					video.parentNode.classList.remove("play");
					btnPlay.classList.remove("paused");
					startAutoplay(sliderElement);
					progressBar.style.display = "none";
					return;
				} else {
					progressBar.style.display = "block";
				}

				// Pausa todos los videos si el video actual está pausado.
				SliderVideoWrapper.forEach((v) => {
					v.pause();
					v.parentNode.classList.remove("play");
					const associatedBtnPlay = v
						.closest(".keen-slider__slide")
						.querySelector(".play-button");
					if (associatedBtnPlay) {
						associatedBtnPlay.classList.remove("paused");
					}
				});
				video.play();
				video.parentNode.classList.add("play");
				btnPlay.classList.add("paused");
				stopAutoplay();
			};

			btnPlay.addEventListener("click", clickHandler);
			// BgBtnPlay.addEventListener("click", clickHandler);
			video.addEventListener("click", clickHandler);

			muteButton.addEventListener("click", () => {
				muteButton.classList.toggle("muted");
				video.muted = !video.muted;
				// muteButton.textContent = video.muted ? 'Unmute' : 'Mute';
			});

			video.addEventListener("timeupdate", () => {
				const currentTime = video.currentTime;
				const duration = video.duration;
				const progressPercentage = (currentTime / duration) * 100;
				progressBar.style.width = `${progressPercentage}%`;
			});

			// Lógica para reproducir el siguiente video automáticamente.
			video.addEventListener("ended", () => {
				progressBar.style.width = "0";
				const nextIndex = (index + 1) % SliderVideoWrapper.length; // Obtener el índice del próximo video
				const nextVideo = SliderVideoWrapper[nextIndex];
				const nextBtnPlay = nextVideo
					.closest(".keen-slider__slide")
					.querySelector(".play-button");

				// Update the src attribute of the next video's source
				const nextSourceTag = nextVideo.querySelector("source[data-src]");
				if (nextSourceTag) {
					const nextVideoSrc = nextSourceTag.getAttribute("data-src");
					nextSourceTag.setAttribute("src", nextVideoSrc);
					nextVideo.load();
				}

				SliderVideoWrapper.forEach((v) => {
					v.pause();
					v.parentNode.classList.remove("play");
					const associatedBtnPlay = v
						.closest(".keen-slider__slide")
						.querySelector(".play-button");
					if (associatedBtnPlay) {
						associatedBtnPlay.classList.remove("paused");
					}
				});

				progressBar.style.display = "block";
				nextVideo.play();
				nextVideo.parentNode.classList.add("play");
				if (nextBtnPlay) {
					nextBtnPlay.classList.add("paused");
				}
				stopAutoplay();

				keenSlider.moveToIdx(nextIndex);
			});
		});
	});
}
